import React from "react";
import {useTranslation} from "react-i18next";
import {setStoredPageSize} from "./storage";

import MDTypography from "../../materialDashboard/components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../materialDashboard/components/MDInput";
import MDBox from "../../materialDashboard/components/MDBox";


const PageEntriesSelector = ({table, entriesPerPage, dataTableId}) => {
    const {t} = useTranslation(["components"]);
    const setPageSize = table.setPageSize;

    const {pagination: {pageSize}} = table.getState()
    const gotoPage = table.setPageIndex;

    const entries = entriesPerPage.entries
        ? entriesPerPage.entries.map((el) => el.toString())
        : ["10", "15", "20", "25", "50", "100", "250"];

    // Set the entries per page value based on the select value
    const setEntriesPerPage = (value) => {
        setPageSize(value);
        gotoPage(0);
        if (dataTableId) {
            setStoredPageSize(dataTableId, value);
        }
    }

    return <MDBox display={{sm: "flex", xs: "none"}} alignItems="center" ml="auto">
        <MDTypography variant="caption" color="secondary">
            {t("dataTable.rowsPerPage")} &nbsp;&nbsp;
        </MDTypography>
        <Autocomplete
            disableClearable
            value={pageSize.toString()}
            options={entries}
            onChange={(event, newValue) => {
                setEntriesPerPage(parseInt(newValue, 10));
            }}
            size="small"
            sx={{width: "5rem"}}
            renderInput={(params) => <MDInput {...params} />}
        />
    </MDBox>
}

export default PageEntriesSelector;